 <div #bingMap class="bing-map"></div> 